import { render, staticRenderFns } from "./BgMenu.vue?vue&type=template&id=4e0c3ece&scoped=true"
import script from "./BgMenu.vue?vue&type=script&lang=js"
export * from "./BgMenu.vue?vue&type=script&lang=js"
import style0 from "./BgMenu.vue?vue&type=style&index=0&id=4e0c3ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0c3ece",
  null
  
)

export default component.exports